<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="600"
	>
		<v-card>
			<!-- Cabecera del formulario -->
			<v-card-title class="headline">
				<v-flex xs9>
					<v-icon>remove_red_eye</v-icon> Ver Detalles
				</v-flex>
				<v-spacer></v-spacer>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>

			<!-- Cuerpo del formulario -->
			<v-form
				v-model="valid"
				ref="form"
				lazy-validation
				>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
                            <v-flex xs12>
							<h3><strong>Descripcion:</strong>   {{form.descripcion }}</h3>
                            </v-flex>
                            <v-flex xs12>
                                <h3><strong>Fecha:</strong>   {{ form.fecha }}</h3>
                            </v-flex>
                            <v-flex xs12>
                                <h3><strong>Tipo de feriado:</strong>   {{ form.tipo }}</h3>
                            </v-flex>
                              <v-flex xs12 v-if="form.nacional==2">
                                <h3><strong>Departamento:</strong>   {{ form.valor }}</h3>
                            </v-flex>
						</v-layout>
						
					</v-container>
				</v-card-text>
				<v-card-actions>
					
					<v-spacer></v-spacer>
					<v-btn
                         color="error"
						@click.native="close()">
						<v-icon>cancel</v-icon> Cerrar
					</v-btn>
					
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate'; // Importación de mixin de validaciones

export default {
	// Definición de mixins importados
	mixins: [validate],
	// Variables iniciales
	data () {
		return {
			tipos_feriados:[{id:1,descripcion:"Nacional"},
			                {id:2,descripcion:"Departamental"},],
			departamentos:[],
			dialog: false,
			form: {},
			valid: false,
			loading: false
		}
	},
	async mounted () {
		this.$bus.$on('openDialogVerFeriado', item => {
            	this.obtenerDepartamentos();
            if (item.nacional==0) {
               item.nacional=2
            } 
            item.id_parametro=item.id_parametro+''
			this.form = item
			this.dialog = true
		})
	},
	methods: {
		close () {
			this.form = {},
			this.loading = false
			this.valid = false
			this.$bus.$emit('closeDialog')
			this.dialog = false
		},
		async obtenerDepartamentos(){
			try {
				  let res = await this.$service.graphql({
						query: `
							query{
							params(tipo:"departamentos"){
								rows{
									id
									valor
								}
							}
						}
							`,
						});
        this.departamentos = res.params.rows;
			} catch (error) {
				console.log(error)
			}
		},
		// async save () {
		// 	if (this.$refs.form.validate()) {
		// 		this.loading = true
		// 		try {
		// 			if (this.form.nacional==2) {
		// 				this.form.nacional=0
		// 			}else{
        //                     this.form.id_parametro=""
        //             }
		// 			let feriado={
		// 							fecha:this.form.fecha,
		// 							descripcion:this.form.descripcion,
		// 							nacional:this.form.nacional,
		// 							id_estado:1,
		// 							id_parametro:this.form.id_parametro,
		// 						}
		// 			console.log("FERIADO:",feriado)
				
					
		// 		} catch (error) {
		// 			console.log(error)
		// 		}
		// 		this.$message.success()
		// 		this.loading = false
		// 		this.close()
		// 	}
		// }
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/feriado/dialogs/VerFeriado.vue